"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addNullArray = addNullArray;
exports.compareSortArr = compareSortArr;
exports.contains = contains;
exports.formaDay = formaDay;
exports.formatAge = formatAge;
exports.formatNumber = formatNumber;
exports.formatTime = formatTime;
exports.getClassifyTree = getClassifyTree;
exports.getDate = getDate;
exports.getDateStr = getDateStr;
exports.getDiffDate = getDiffDate;
exports.getTagName = getTagName;
exports.getTargetDate = getTargetDate;
exports.getTree = getTree;
exports.getTreeMap = getTreeMap;
exports.getUrl = getUrl;

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/web.url.js");

require("core-js/modules/web.url-search-params.js");

require("core-js/modules/es.string.starts-with.js");

require("core-js/modules/es.string.replace.js");

// code换取tagName
function getTagName(data, tagCode) {
  var tagName = '';
  data.map(function (item) {
    if (tagCode == item.tagCode) {
      tagName = item.tagName;
    }
  });
  return tagName;
} // 排班管理-生成一周数据空数组


function addNullArray() {
  var common = [];

  for (var i = 0; i < 7; i++) {
    common.push({
      startHm: '',
      endHm: ''
    });
  }

  return common;
} // 获取年龄


function formatAge(ageDate) {
  var date = new Date();
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var ageArr = ageDate ? ageDate.split('-') : '';
  var res = '';

  if (ageArr && ageArr.length) {
    var ageMonth = parseInt(ageArr[0]) * 12 + parseInt(ageArr[1]);
    var newMonth = parseInt(year) * 12 + parseInt(month);

    if (newMonth - ageMonth < 12) {
      res = "".concat((newMonth - ageMonth) % 12, " \u4E2A\u6708");
    } else if (newMonth - ageMonth > 12 && newMonth - ageMonth < 36) {
      res = "".concat(Math.floor((newMonth - ageMonth) / 12), " \u5C81 ").concat((newMonth - ageMonth) % 12, " \u4E2A\u6708");
    } else {
      res = "".concat(year - ageArr[0], "\u5C81");
    }
  }

  return res;
} // 获取相同元素所在数组的数组元素下标


function contains(arrays, obj) {
  var i = arrays.length;

  while (i--) {
    if (arrays[i].label === obj) {
      return i;
    }
  }

  return false;
} // 排班管理——排班表——时间选择器的时间段参数获取


function getDiffDate(start, end) {
  var startTime = getDate(start);
  var endTime = getDate(end);
  var dateArr = [];

  while (endTime.getTime() - startTime.getTime() > 0) {
    var year = startTime.getFullYear();
    var month = startTime.getMonth().toString().length === 1 ? '0' + (parseInt(startTime.getMonth().toString(), 10) + 1) : startTime.getMonth() + 1;
    var day = startTime.getDate().toString().length === 1 ? '0' + startTime.getDate() : startTime.getDate();
    dateArr.push(year + '-' + month + '-' + day);
    startTime.setDate(startTime.getDate() + 1);
  }

  return dateArr;
}

function getDate(datestr) {
  var temp = datestr.split('-');

  if (temp[1] === '01') {
    temp[0] = parseInt(temp[0], 10) - 1;
    temp[1] = '12';
  } else {
    temp[1] = parseInt(temp[1], 10) - 1;
  } // new Date()的月份入参实际都是当前值-1


  var date = new Date(temp[0], temp[1], temp[2]);
  return date;
} // 格式化时间


function formatTime(date) {
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var hour = date.getHours();
  var minute = date.getMinutes();
  var second = date.getSeconds();
  return [year, month, day].map(formatNumber).join('/') + ' ' + [hour, minute, second].map(formatNumber).join(':');
} // 格式化日期


function formaDay(date) {
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  return [year, month, day].map(formatNumber).join('-');
}

function formatNumber(n) {
  n = n.toString();
  return n[1] ? n : '0' + n;
} // startDate: 计划开始时间； endDate：计划结束时间；dayLength：每隔几天，0-代表每天，1-代表日期间隔一天


function getDateStr(startDate, endDate, dayLength, frequency) {
  var str = [startDate];

  if (endDate) {
    for (var i = 1;; i++) {
      var _getDate = getTargetDate(startDate, dayLength);

      startDate = _getDate;

      if (_getDate <= endDate) {
        str.push(_getDate);
      } else {
        break;
      }
    }
  } else {
    for (var i = 1; i < frequency; i++) {
      var _getDate2 = getTargetDate(startDate, dayLength);

      startDate = _getDate2;
      str.push(_getDate2);
    }
  }

  return str;
} // startDate: 开始时间；dayLength：每隔几天，0-代表获取每天，1-代表日期间隔一天


function getTargetDate(date, dayLength) {
  dayLength = parseInt(dayLength) + 1;
  var tempDate = new Date(date);
  tempDate.setDate(tempDate.getDate() + parseInt(dayLength));
  var year = tempDate.getFullYear();
  var month = tempDate.getMonth() + 1 < 10 ? '0' + (tempDate.getMonth() + 1) : tempDate.getMonth() + 1;
  var day = tempDate.getDate() < 10 ? '0' + tempDate.getDate() : tempDate.getDate();
  return year + '-' + month + '-' + day;
}

function compareSortArr(property) {
  // 数组排序使用函数
  return function (a, b) {
    var value1 = a[property];
    var value2 = b[property];
    return value1 - value2;
  };
}
/* 获取图片完整地址 */


function getUrl(url) {
  if (!url) {
    return '';
  }

  if (url instanceof File) {
    return URL.createObjectURL(url);
  }

  if (url.startsWith('http')) {
    if (url.startsWith('http:')) {
      url = url.replace('http:', 'https:');
    }
  } else if (url.startsWith('blob:http://')) {
    return url;
  } else {
    if (!url.startsWith('/')) {
      url = '/' + url;
    }

    url = process.env.VUE_APP_RESOURCE_CDN_URL + url;
  }

  return url;
} // 多预制体类型整理


function getClassifyTree(list) {
  var classifyMap = {};

  for (var i = 0, len = list.length; i < len; i++) {
    if (!classifyMap[list[i].tag_id]) {
      classifyMap[list[i].tag_id] = [];
    }

    classifyMap[list[i].tag_id].push(list[i]);
  }

  for (var tag_id in classifyMap) {
    classifyMap[tag_id] = getTree(classifyMap[tag_id]);
  }

  return classifyMap;
} // 单预制体类型整理


function getTree(list) {
  var temp = {};
  var tree = [];

  for (var i in list) {
    temp[list[i].tag_id] = list[i];
  }

  for (var key in temp) {
    if (temp[key].tag_parent) {
      if (!temp[temp[key].tag_parent].tag_list) {
        temp[temp[key].tag_parent].tag_list = [];
      }

      temp[temp[key].tag_parent].tag_list.push(temp[key]);
    } else {
      tree.push(temp[key]);
    }
  } // console.log(tree)


  return tree;
} // 排序


function tagSort(a, b) {
  return a.order_no < b.order_no ? 1 : -1;
}

function getTreeMap(list) {
  var temp = {};
  var tree = {};

  for (var i in list) {
    temp[list[i].tag_id] = list[i];
  } // console.log(temp)


  for (var key in temp) {
    if (temp[key].tag_parent) {
      if (!temp[temp[key].tag_parent].tagList) {
        temp[temp[key].tag_parent].tagList = [];
      }

      temp[temp[key].tag_parent].tagList.push(temp[key]);
    } else {
      if (!temp[key].tagList) {
        temp[key].tagList = [];
      }

      tree[key] = temp[key];
    }
  }

  console.log(tree);
  return tree;
}